import { useState, useEffect } from "react"
import { useParams, useHistory} from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, ListGroup, ListGroupItem, Row, Col } from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader";
import PbxGroupService from "core/api/PbxGroupService";
import { CrudDropdownEditDelete } from "views/Shared/CrudDropdownEditDelete";


const View = () => {
    const { id } = useParams();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const history = useHistory();


    useEffect(() => {
        async function fetchData() {
            const pbxGroup = await PbxGroupService.get(id);

            setData(pbxGroup);

            setLoading(false);
        }
        fetchData();
    }, [])

    if (loading) return <>Loading</>;
    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h1 className="title">
                            Pbx Group
                        </h1>
                        <h2 className="title">
                            {data?.name}
                        </h2>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <CardTitle tag="h4">Pbx Group</CardTitle>
                                <Col xs="auto">
                                    <CrudDropdownEditDelete
                                        id={id}
                                        onDelete={() => {
                                            PbxGroupService.delete(id);
                                            history.goBack();
                                        }}
                                        deletePermissions={["all:pbxGroups", "delete:pbxGroups", "admin"]}
                                        editPermissions={["all:pbxGroups", "write:pbxGroups", "admin"]}
                                    />
                                </Col>
                            </CardHeader>
                            <CardBody>
                                <ListGroup >
                                    <ListGroupItem>
                                        <strong>Name:</strong> {data?.name}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Primary Url:</strong> {data?.primaryUrl}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Backup Url:</strong> {data?.backupUrl}
                                    </ListGroupItem>

                                </ListGroup>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </div >

        </>
    )
}

export default View